import THInfoModal from "./THInfoModal";

export default THInfoModal;
